"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.ProductCrossActivationButton = void 0;

var _productsStatus = require("../productsStatus");

var _Loader = _interopRequireDefault(require("../../../../../components/Loader/Loader"));

var _Popup = _interopRequireDefault(require("../../../../../components/Popup/Popup"));

var _react = _interopRequireDefault(require("react"));

var ProductCrossActivationButton = function ProductCrossActivationButton(_ref) {
  var status = _ref.status,
      inverted = _ref.inverted;

  switch (status) {
    case _productsStatus.PRODUCT_STATUS.LOADING:
      return /*#__PURE__*/_react["default"].createElement(_Loader["default"], {
        inverted: true,
        inline: true,
        size: "small",
        className: "product-loader"
      });

    case _productsStatus.PRODUCT_STATUS.CAN_ACTIVATE:
      return /*#__PURE__*/_react["default"].createElement("div", {
        "data-qa": "try-now-info",
        className: "product-info"
      }, "try now");

    case _productsStatus.PRODUCT_STATUS.ACCESS_NEEDED:
      return /*#__PURE__*/_react["default"].createElement(_Popup["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement("div", {
          "data-qa": "request-access-info",
          className: "product-info"
        }, "request access"),
        position: 'top center',
        flowing: true,
        inverted: inverted
      }, /*#__PURE__*/_react["default"].createElement(_Popup["default"].Content, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "cloud-ui-nav-tooltip"
      }, "Ask the owner for access or switch to an organization with access to the product.")));

    default:
      return null;
  }
};

exports.ProductCrossActivationButton = ProductCrossActivationButton;